import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.CardControls', {
    details: 'Details',
    fund: 'Fund',
    transactions: 'Transactions',
    hide: 'Hide',
});
